export interface SeguridadComponenteMeta {
    titulo: string;
    descripcion: string;
    icono: string;
    ruta: string;
}

export const SEGURIDAD_COMPONENTES: SeguridadComponenteMeta[] = [
    {
        titulo: 'Usuarios',
        descripcion: 'Gestione los usuarios del sistema: altas, bajas y modificaciones.',
        icono: 'people',
        ruta: '/usuarios-administracion',
    },
    {
        titulo: 'Roles',
        descripcion: 'Alta, baja y modificación de roles del sistema.',
        icono: 'admin_panel_settings',
        ruta: '/roles-administracion',
    },
    {
        titulo: 'Permisos',
        descripcion: 'Gestione los permisos de acceso a funcionalidades del sistema.',
        icono: 'shield',
        ruta: '/permisos-administracion',
    },
    {
        titulo: 'Menúes',
        descripcion: 'Alta, baja y modificación de los menúes del sistema.',
        icono: 'menu',
        ruta: '/menues-administracion',
    },
];
